//@flow
import React, { Component } from "react";
import "./mobile-actions.scss";
import AddWishlistToCart from "../add-wishlist-to-cart";

import type { ProductType } from "../types/product";
import type { ProductPurchasability } from "../types/publicpurchasable";

type Props = {
  products: ProductType[],
  productPurchasabilityMap: Map<number, ProductPurchasability>,
  isPostCodeAvailable: boolean,
  isLoadingPurchasability: boolean
};

class MobileActions extends Component<Props> {
  render() {
    return (
      <div className="wishlist-floating-btn-group">
        {this.props.products.length > 0 && (
          <AddWishlistToCart
            className="btn-with-loader wishlist-floating-btn-group__add-to-cart"
            products={this.props.products}
            isPostCodeAvailable={this.props.isPostCodeAvailable}
            productPurchasabilityMap={this.props.productPurchasabilityMap}
            isLoadingPurchasability={this.props.isLoadingPurchasability}
          />
        )}
        <a
          href="/bathrooms/book-a-consultation"
          className="wishlist-floating-btn-group__cta"
        >
          Request an appointment
        </a>
      </div>
    );
  }
}

export default MobileActions;
